import { Box, HStack, Image, Text } from "@chakra-ui/react";
import { Link } from "react-router-dom";
import { PostsLandingInterface } from "../../../constants/Landing";
import { useBgHover } from "../../../themes/colors";
import { formatDateToDayMonthYear } from "../../../utils/helperFunction";

interface blogCardPropsType {
  item: PostsLandingInterface | undefined;
}

const BlogCard = ({ item }: blogCardPropsType) => {
  const bgHover = useBgHover();

  return (
    <HStack
      p={2}
      as={Link}
      to={`/blog/${item && item.slug}`}
      alignItems="center"
      gap={"12px"}
      _hover={{ bg: bgHover }}
      borderRadius={["md", null, "lg"]}
    >
      <Image
        src={
          item?.thumbnail
            ? `${process.env.REACT_APP_MEDIA_URL}${item && item.thumbnail}`
            : ""
        }
        fallbackSrc="/assets/svg/illustration_empty.svg"
        alt={item?.title || "Image Blog"}
        w={{ base: "117px", xl: "142px" }}
        h={{ base: "117px", xl: "142px" }}
        objectFit="cover"
        mb="2"
        rounded={"12px"}
      />

      <Box>
        <Text textStyle={"h-reg-title"} noOfLines={2}>
          {item && item.title}
        </Text>

        <Text
          textStyle={"b-sm"}
          mt={"2px"}
          noOfLines={3}
          textOverflow={"ellipsis"}
          variant={"secondary"}
        >
          {item && item.preview}
        </Text>

        <Text textStyle={"b-sm"} mt={"12px"} variant={"secondary"}>
          {item &&
            item.posted_date &&
            formatDateToDayMonthYear(item?.posted_date.toString())}
        </Text>
      </Box>
    </HStack>
  );
};

export default BlogCard;
